<template>
  <div class="flex items-center gap-2 pt-4 border-t border-gray-100">
    <slot />
  </div>
</template>
